export const languageToFlag = (language: string): string => {
  switch (language.toLowerCase()) {
    case 'english':
      return '🇬🇧';
    case 'dutch':
      return '🇳🇱';
    case 'french':
      return '🇫🇷';
    case 'german':
      return '🇩🇪';
    case 'spanish':
      return '🇪🇸';
    default:
      return language;
  }
};
